var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGlobePrimary = function SvgIconGlobePrimary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-globe-primary_svg__a)",
    d: "M20 15.998q-.001 1.285-.104 2.485a.2.2 0 0 1-.199.182h-7.395a.2.2 0 0 1-.198-.182 29.4 29.4 0 0 1 0-4.97.2.2 0 0 1 .198-.182h7.395c.104 0 .19.08.199.182.068.799.104 1.63.104 2.485"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-globe-primary_svg__b)",
    d: "M22.774 13.331c-.117 0-.209.1-.2.217a32 32 0 0 1 0 4.9.2.2 0 0 0 .2.217h6.129a.2.2 0 0 0 .195-.16 13.4 13.4 0 0 0 0-5.013.2.2 0 0 0-.195-.16z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-globe-primary_svg__c)",
    d: "M28.098 10.386a.196.196 0 0 1-.18.279H22.38a.2.2 0 0 1-.198-.166c-.535-2.908-1.481-5.353-2.68-6.984-.116-.157.027-.38.213-.326a13.37 13.37 0 0 1 8.383 7.197"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-globe-primary_svg__d)",
    d: "M19.45 10.426a.198.198 0 0 1-.194.239h-6.512a.198.198 0 0 1-.195-.24c.296-1.415.697-2.665 1.164-3.694 1.126-2.476 2.287-3.7 2.439-3.7s1.01 1.224 2.134 3.7c.468 1.029.868 2.279 1.164 3.695"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-globe-primary_svg__e)",
    d: "M9.62 10.665c.097 0 .18-.07.198-.166.534-2.908 1.481-5.353 2.68-6.984.115-.157-.027-.38-.213-.326a13.37 13.37 0 0 0-8.383 7.197c-.061.13.035.279.18.279z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-globe-primary_svg__f)",
    d: "M3.097 13.331a.2.2 0 0 0-.195.16 13.4 13.4 0 0 0 0 5.013c.017.094.1.16.195.16h6.129c.117 0 .209-.1.2-.216a32 32 0 0 1 0-4.9.2.2 0 0 0-.2-.217z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-globe-primary_svg__g)",
    d: "M13.713 25.265c-.467-1.029-.868-2.279-1.164-3.695a.198.198 0 0 1 .195-.239h6.512c.125 0 .22.116.194.239-.296 1.416-.696 2.666-1.164 3.695-1.125 2.476-1.982 3.7-2.134 3.7s-1.314-1.224-2.439-3.7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-globe-primary_svg__h)",
    d: "M9.818 21.497a.2.2 0 0 0-.198-.166H4.082a.197.197 0 0 0-.18.279 13.37 13.37 0 0 0 8.383 7.197c.186.054.328-.17.213-.326-1.199-1.631-2.145-4.076-2.68-6.984"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-globe-primary_svg__i)",
    d: "M28.098 21.61a.197.197 0 0 0-.18-.279H22.38c-.097 0-.18.07-.198.166-.535 2.908-1.481 5.353-2.68 6.984-.116.156.027.38.213.326a13.37 13.37 0 0 0 8.383-7.197"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-globe-primary_svg__a",
    x1: 13.236,
    x2: 18.735,
    y1: 12.041,
    y2: 34.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-globe-primary_svg__b",
    x1: 13.236,
    x2: 18.735,
    y1: 12.041,
    y2: 34.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-globe-primary_svg__c",
    x1: 13.236,
    x2: 18.735,
    y1: 12.041,
    y2: 34.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-globe-primary_svg__d",
    x1: 13.236,
    x2: 18.735,
    y1: 12.041,
    y2: 34.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-globe-primary_svg__e",
    x1: 13.236,
    x2: 18.735,
    y1: 12.041,
    y2: 34.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-globe-primary_svg__f",
    x1: 13.236,
    x2: 18.735,
    y1: 12.041,
    y2: 34.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-globe-primary_svg__g",
    x1: 13.236,
    x2: 18.735,
    y1: 12.041,
    y2: 34.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-globe-primary_svg__h",
    x1: 13.236,
    x2: 18.735,
    y1: 12.041,
    y2: 34.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-globe-primary_svg__i",
    x1: 13.236,
    x2: 18.735,
    y1: 12.041,
    y2: 34.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B2"
  })))));
};
export default SvgIconGlobePrimary;